import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b554bfc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sound-therapy-tabs" }
const _hoisted_2 = ["onClick"]

import { UiTherapyTabItemI } from '@/types/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'TherapyListTabs',
  props: {
    tabs: {},
    selectedTabValue: {}
  },
  emits: ["update:selectedTabValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, tI) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tI,
        type: "button",
        class: _normalizeClass([
        'sound-therapy-tabs__item',
        {
          'sound-therapy-tabs__item--active': _ctx.selectedTabValue === tab.value,
        },
      ]),
        onClick: ($event: any) => (emit('update:selectedTabValue', tab.value))
      }, _toDisplayString(tab.title || tab.value), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})